import { useLeavePageWarning } from "./useLeavePageWarning.mjs";
import { nextTick, ref, watch } from "vue";
export function useManagePage(dataResetFunction = null, options = {}) {
  const data = ref({});
  watch(data, () => {
    hasChanges.value = true;
  }, { deep: true });
  const isLoading = ref(false);
  const hasChanges = ref(false);
  useLeavePageWarning(hasChanges);
  function reset() {
    if (dataResetFunction) {
      dataResetFunction(data);
    } else {
      data.value = {};
    }
    handleAfterReset();
  }
  function handleAfterReset() {
    nextTick(() => {
      hasChanges.value = false;
    });
  }
  function handleSavedEvent() {
    nextTick(() => {
      hasChanges.value = false;
    });
  }
  if (options.resetDataPending) {
    watch(options.resetDataPending, (newValue) => {
      if (!newValue) {
        reset();
      }
    }, { immediate: true });
  } else {
    reset();
  }
  return {
    data,
    isLoading,
    hasChanges,
    reset,
    handleSavedEvent,
    handleAfterReset
  };
}
